import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate, formatData, isNullOrEmpty, showMessageToastCustom, getUserNameToName, closeCollapsible } from '../../../../utils/util';
import { Input, BackButton, Title, Subtitle, Button, ListPaginationNew, Fab, Collapsible } from '../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import ReprocessModal from './ReprocessModal'
import StockService from '../../../../services/StockService';
import { createAndSaveWorkbookMerge, createSheetToJson } from '../../../../utils/worksheetUtil';

const ReprocessSearch = (props) => {
    const initialValues = {
        partNumber: null,
        area: null,
        createdBy: null,
        dateStart: null,
        dateEnd: null,
        upload: true,
        reprocess: true
    }

    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [filterSearch, setFilterSearch] = useState(initialValues)
    const [selectedItems, setSelectedItems] = useState([])
    const [reprocessModalOpen, setReprocessModalOpen] = useState(false)
    const [selectAll, setSelectAll] = useState(false)
    const [modalType, setModalType] = useState(0)
    const [orderDirection, setOrderDirection] = useState("ASC")

    useEffect(() => {
        setData([]);
        setTotalPages(0);
        setCurrentPage(0);

        //getInfo();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (modalType > 0) {
            setReprocessModalOpen(true)
        }
        // eslint-disable-next-line
    }, [modalType]);

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage, orderDirection]);

    const onSearch = (refreshing) => {
        props.getTransmissions({
            ...filterSearch,
            OrderDirection: orderDirection,
            PageSize: 30,
            PageIndex: currentPage
        }, (c) => {
            let list = [];
            Object.assign(list, data);
            refreshing ? list = c.items : list.push(...c.items)
            setData(list);
            setTotalPages(c.totalPages);

            closeCollapsible("CollapsibleRepro")
        });
    }



    const exportReport = () => {
        props.getTransmissions({
            ...filterSearch,
            OrderDirection: orderDirection,
            PageSize: 10000000,
            PageIndex: currentPage
        }, (c) => {
            const dataExport = [];
            c.items.forEach(item => {
                dataExport.push({
                    "Desenho": item.partNumber,
                    "Área": item.area,
                    "Detalhes": jsonFormatDetails(item),
                    "Quantidade Baixada": item.quantityDownloaded,
                    "Arquivo Upload": item.fileName,
                    "Usuário Upload": getUserNameToName(props.usersFromElog, item.createdBy),
                    "Data Upload": formatData(item.createdOn),
                    "Tentativas": item.attempts,
                    "Último Reprocessamento": formatData(item.updatedOn)
                })
            });
            createAndSaveWorkbookMerge([createSheetToJson(dataExport)], "reprocessamento.xlsx")    
        });
    }

    const onChange = (event) => {
        onValueChange(event, filterSearch, setFilterSearch);
    };

    const onClick = () => {
        setData([])
        setCurrentPage(0);
        onSearch(true)
    }

    const onDelete = (item) => {
        props.deleteTransmission(item.id, () => { onSearch(true); });

        removeSelected(item)
    }

    const addSelectedItem = (item) => {
        if (selectedItems.some(e => e.id === item.id)) {
            removeSelected(item)
        } else {
            let list = [];
            Object.assign(list, selectedItems);
            list.push(item)
            setSelectedItems(list);
        }
    }

    const redirect = (item) => {
        props.history.push({
            pathname: `reprocessedit`,
            state: { change: item }
        });
    }

    const deleteAll = () => {
        setModalType(3);
    }

    const sendAll = () => {
        props.reprocessAllTransmission(filterSearch, () => { onSearch(true); });
    }

    const removeSelected = (item) => {
        let list = [];
        Object.assign(list, selectedItems);
        let index = list.findIndex(x => x.id === item.id)
        list.splice(index, 1);
        setSelectedItems(list)
        setSelectAll(false)
    }

    const onClickSelectAll = () => {
        if (selectAll) {
            setSelectAll(false)
            setSelectedItems([])
        } else {
            setSelectAll(true)
            setSelectedItems(data)
        }
    }

    const onConfirmModal = () => {
        const selectedIds = selectedItems.map(x => x.id);
        if (modalType === 1) {
            props.deleteSelected(selectedIds, () => {
                handleBack()
            });
        } else if (modalType === 2) {
            props.reprocessSelected(selectedIds, (data) => {
                if (data?.success) {
                    showMessageToastCustom(translate('general.info'), data?.message, 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                } else {
                    showMessageToastCustom(translate('warning', 'general'), data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }
                handleBack()
            });
        }
        else if (modalType === 3) {
            props.deleteAllTransmission(filterSearch, () => {
                onSearch(true);
                handleBack();
            });
        }
    }

    const handleBack = () => {
        onSearch(true);
        setReprocessModalOpen(false)
        setSelectedItems([])
        setModalType(0)
    }

    const handleSelected = (type) => {
        if (selectedItems.length === 0) {
            return showMessageToastCustom(translate('warning', 'general'), "Nenhum item selecionado", 3000, 'mdi mdi-alert-circle-outline red-text');
        }
        setModalType(type)
    }

    const updateOrder = () => {
        window.scrollTo(0, 0)
        let newOrder = orderDirection === "ASC" ? "DESC" : "ASC";
        setOrderDirection(newOrder)
        setData([])
        setCurrentPage(0);
    }

    const jsonFormatDetails = (item) => {
        try {
            return JSON.parse(item.jsonResponse).DETALHES
        } catch {
            return item.jsonResponse
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <Title icon="mdi mdi-clipboard-list-outline" label={translate('reprocess-monitor', 'physical-confirmation')} />
            <Subtitle icon="mdi mdi-clipboard-list-outline" label={translate('stock:upload')} />
            <div className="container-fluid" style={{ paddingTop: '2px' }}>
                <div className="container" >
                    <Collapsible
                        id="CollapsibleRepro"
                        header={translate('line-picking:linepicking.filter')}
                        body={
                            <>
                                <form id="getReport" className="row no-margin-bottom">
                                    <div className="row">
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                defaultValue={filterSearch.dateStart}
                                                type="date"
                                                label={translate('change-location:startDate')}
                                                id="dateStart"
                                                name="dateStart"
                                                onChange={onChange}
                                                required={!isNullOrEmpty(filterSearch.dateEnd)}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                defaultValue={filterSearch.dateEnd}
                                                type="date"
                                                label={translate('change-location:endDate')}
                                                id="dateEnd"
                                                name="dateEnd"
                                                onChange={onChange}
                                                required={!isNullOrEmpty(filterSearch.dateStart)}
                                            />
                                        </div>
                                        <div className="input-field no-padding no-margin-top col s5">
                                            <Input
                                                id="area"
                                                name="area"
                                                label={translate('stock:area')}
                                                type="text"
                                                maxLength={10}
                                                defaultValue={filterSearch.area}
                                                onChange={onChange}
                                                onBlur={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding no-margin-top col s6">
                                            <Input
                                                id="partNumber"
                                                name="partNumber"
                                                label={translate('change-location:drawing')}
                                                type="text"
                                                maxLength={11}
                                                defaultValue={filterSearch.partNumber}
                                                onChange={onChange}
                                                onBlur={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding no-margin-top col s11">
                                            <Input
                                                id="createdBy"
                                                name="createdBy"
                                                label={translate('general:user')}
                                                type="text"
                                                defaultValue={filterSearch.createdBy}
                                                onChange={onChange}
                                                onBlur={onChange}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ marginBottom: '5px' }}>
                                    <Button full="true" onClick={() => onClick()} text={translate('search', 'general')} />
                                </div>
                                <div className="row" style={{ marginBottom: '5px' }}>
                                    <Button full="true" onClick={() => exportReport()} text={translate('download', 'general')} />
                                </div>
                                {data.length > 0 &&
                                    <div className="row" style={{ marginTop: '10px' }}>
                                        {selectedItems.length <= 0 ?
                                            <div>
                                                <div className="col s6 no-padding m6">
                                                    <Button full="true" onClick={() => sendAll()} text={translate('change-location:reprocess-all')} />
                                                </div>

                                                <div className="col s6 no-padding m6">
                                                    <Button full="true" onClick={() => deleteAll()} text={translate('change-location:delete-all')} secundary="true" />
                                                </div>
                                            </div> :
                                            <div>
                                                <div className="col s6 no-padding m6">
                                                    <Button full="true" onClick={() => handleSelected(2)} text={translate('change-location:reprocess-selected')} />
                                                </div>
                                                <div className="col s6 no-padding m6">
                                                    <Button full="true" onClick={() => handleSelected(1)} text={translate('change-location:delete-selected')} secundary="true" />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </>
                        }
                    />
                    {data.length > 0 &&
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div onClick={() => updateOrder()} className="sixth-text-color flex-center" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} >
                                <i className={`mdi mdi-menu-${orderDirection === "ASC" ? 'up' : 'down'} f24`} />
                                <b>{translate('order', 'general')}</b>
                            </div>
                            <div className='flex-center' >
                                <b className="sixth-text-color">{translate('SelectAll', 'general')}</b>
                                <span className="title sixth-text-color" >
                                    <i
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => onClickSelectAll()}
                                        className={`mdi mdi-checkbox-multiple-marked ${selectAll ? 'green' : 'gray'}-text`}
                                    />
                                </span>
                            </div>
                        </div>
                    }
                    <ListPaginationNew
                        page={totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={data.map((item, index) => {
                            return (
                                <div
                                    style={{ display: 'block', padding: '10px', height: 'auto' }}
                                    key={`oi-${index}`}
                                >
                                    <span className="title sixth-text-color right" style={{ marginTop: '0px' }}>
                                        <i
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => addSelectedItem(item)}
                                            className={`mdi mdi-checkbox${selectedItems.some(e => e.id === item.id) ? '-marked green' : '-blank-outline gray'}-text`}
                                        />
                                    </span>
                                    <span className="title sixth-text-color right">
                                        <i style={{ cursor: 'pointer' }} onClick={() => onDelete(item)} className="mdi mdi-delete"></i>
                                    </span>
                                    <div onClick={() => redirect(item)}>
                                        <span className="sixth-text-color" style={{ display: 'block' }}>{item.partNumber}</span>
                                        <b className="sixth-text-color" style={{ display: 'block' }}>{item.area}{(!isNullOrEmpty(item.quantity) && item.quantity > 0) ? ` - ${item.quantity}` : ''}</b>
                                        <i className="sixth-text-color" style={{ display: 'block' }}>{jsonFormatDetails(item)}</i>
                                        <b className="sixth-text-color" style={{ display: 'block' }}>{'Quantidade Baixada'}: {item.quantityDownloaded ?? 0} </b>
                                        <span className="sixth-text-color" style={{ display: 'block' }}>{item.fileName ?? ""}</span>
                                        <b className="sixth-text-color">{translate('change-location:upload')}: </b>
                                        <span className="sixth-text-color">{getUserNameToName(props.usersFromElog, item.createdBy)} | {formatData(item.createdOn)}</span><br />
                                        <b className="sixth-text-color">{translate('change-location:last-reprocess')}: </b>
                                        <span className="sixth-text-color">{item.updatedBy} | {formatData(item.updatedOn)}</span><br />
                                        <b className="sixth-text-color">{translate('attempts', 'physical-confirmation')}: </b>
                                        <span className="sixth-text-color">{item.attempts || ''}</span><br />
                                    </div>
                                    <span className="sixth-text-color right" style={{ marginTop: '-20px' }}>
                                        {index + 1}
                                    </span>
                                </div>
                            );
                        })}
                    />
                </div>
            </div>
            {data.length > 0 &&
                <Fab
                    buttons={[
                        { label: translate('change-location:top'), icon: <i className="mdi mdi-publish" />, color: 'darkgreen', onClick: () => { window.scrollTo(0, 0) } },
                        { label: translate('change-location:reprocess-selected'), icon: <i className="mdi mdi-publish" />, onClick: () => handleSelected(2) },
                        { label: translate('change-location:delete-selected'), icon: <i className="mdi mdi-delete" />, onClick: () => handleSelected(1) },
                        { label: translate('change-location:reprocess-all'), color: 'darkred', icon: <i className="mdi mdi-arrow-up-thick" />, onClick: () => sendAll() },
                        { label: translate('change-location:delete-all'), color: 'darkred', icon: <i className="mdi mdi-delete-forever" />, onClick: () => deleteAll() }
                    ]}
                />
            }
            <ReprocessModal
                open={reprocessModalOpen}
                id="ConfirmModalPackList"
                selectedItems={selectedItems}
                onCancel={() => setReprocessModalOpen(false)}
                onConfirm={() => onConfirmModal()}
                onDelete={(data) => removeSelected(data.id)}
                modalType={modalType}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTransmissions: (filter, callback) => {
            dispatch(StockService.getTransmissions(filter, callback));
        },
        deleteTransmission: (id, callback) => {
            dispatch(StockService.deleteTransmission(id, callback));
        },
        deleteAllTransmission: (filter, callback) => {
            dispatch(StockService.deleteAllTransmission(filter, callback));
        },
        reprocessAllTransmission: (filter, callback) => {
            dispatch(StockService.reprocessAllTransmission(filter, callback));
        },
        deleteSelected: (selectedIds, callback) => {
            dispatch(StockService.deleteTransmissions(selectedIds, callback));
        },
        reprocessSelected: (selectedIds, callback) => {
            dispatch(StockService.reprocessSelected(selectedIds, callback));
        },
        getInfo: (filter, callback) => {
            dispatch(StockService.getInfo(filter, callback));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReprocessSearch)));

